import { useTranslation } from 'react-i18next';
import { Body2 } from '@/components/@IntranetLibrary/Typography';
import ProductionCostTables from '@/components/Approval/@components/ProductionCost';
import {
  parseProductionCostData,
  productionCostNotesByCode,
  toClosingMonth,
} from '@/utils/approval/productionCost';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 216 생산비 마감(회계) — 저장 data 로 표를 다시 그림(레거시 조회와 동일, 레거시 문서 포함). SAP 재조회 안 함 */
const ProductionCostSlot = ({ data }: ContentExtraProps) => {
  const { t, i18n } = useTranslation();
  const saved = parseProductionCostData(data.attributes);
  if (!saved) return null;
  const closingMonth = toClosingMonth(saved.closing_month);
  return (
    <ContentSlotRoot>
      <ProductionCostTables
        closingMonth={closingMonth}
        monthSlot={
          <Body2 sx={{ color: 'var(--dk-text, #131313)' }}>
            {closingMonth}
          </Body2>
        }
        settlement={saved.api_data}
        notes={productionCostNotesByCode(saved.diff_notes)}
        t={t}
        lang={i18n.language}
      />
    </ContentSlotRoot>
  );
};

export default ProductionCostSlot;
